import React, { useEffect, useState } from 'react';
import { AbstractDropDown, AbstractDropDownProps, Option } from "../AbstractDropDown";
import { useAuthStore } from "../../../store/auth.store";
import { loadSources } from "../../../service/proposal.service";
import { enqueueSnackbar } from "notistack";

export function SourceDropdown (props:AbstractDropDownProps){
    const {can} = useAuthStore();
    const fullAcces = can('full_access')
    const [options, setOptions] = useState<Option[]>([]);
    useEffect(() => {
        if(fullAcces) {
            let isLocalHost = document.location.hostname.indexOf('localhost') > -1;
            loadSources().then((response) => {
                setOptions([{value: '', label: <span>&nbsp;</span>}, ...response.data
                    .filter(s => isLocalHost || (s !== 'onliner'))
                    .map(s => ({label: s, value: s}))]);
            }).catch(e => {
                if(e.status !== 401) {
                    enqueueSnackbar({message: "Failed to load sources list: " + e.message, variant: "error"})
                } else {
                    console.log("Seems user not authorized anymore, can't load sources list");
                }
            })
        }
    }, [fullAcces]);
    if(!fullAcces) {
        return null;
    }
    return <AbstractDropDown {...props} options={options}/>;
};